import {NgModule} from '@angular/core';
import {NoContentPageComponent} from './no-content-page.component';

@NgModule({
    declarations: [
        NoContentPageComponent
    ],
    exports: [
        NoContentPageComponent
    ]
})
export class NoContentPageModule {}
